module.exports = __webpack_public_path__ + "img/banner.9369a566.png";